import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region ../icons/dist/react/minimal/spinner.js
const SpinnerIcon = (props, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeWidth: 2,
	"aria-hidden": "true",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: [
		/* @__PURE__ */ jsx("style", { children: "@keyframes media-spinner-fade{0%{opacity:1}to{opacity:0}}.media-spinner__segment{animation:var(--media-spinner-animation, media-spinner-fade 1s steps(8, end) infinite);animation-delay:var(--media-spinner-delay)}@media (prefers-reduced-motion:reduce){.media-spinner__segment{animation:none}}" }),
		/* @__PURE__ */ jsx("path", {
			d: "M9 1.5v3",
			className: "media-spinner__segment",
			opacity: .5,
			style: { "--media-spinner-delay": "0s" }
		}),
		/* @__PURE__ */ jsx("path", {
			d: "m14.5 3.5-2 2",
			className: "media-spinner__segment",
			opacity: .45,
			style: { "--media-spinner-delay": "0.125s" }
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M16.5 9h-3",
			className: "media-spinner__segment",
			opacity: .4,
			style: { "--media-spinner-delay": "0.25s" }
		}),
		/* @__PURE__ */ jsx("path", {
			d: "m14.5 14.5-2-2",
			className: "media-spinner__segment",
			opacity: .35,
			style: { "--media-spinner-delay": "0.375s" }
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M9 16.5v-3",
			className: "media-spinner__segment",
			opacity: .3,
			style: { "--media-spinner-delay": "0.5s" }
		}),
		/* @__PURE__ */ jsx("path", {
			d: "m3.5 14.5 2-2",
			className: "media-spinner__segment",
			opacity: .25,
			style: { "--media-spinner-delay": "0.625s" }
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M1.5 9h3",
			className: "media-spinner__segment",
			opacity: .15,
			style: { "--media-spinner-delay": "0.75s" }
		}),
		/* @__PURE__ */ jsx("path", {
			d: "m3.5 3.5 2 2",
			className: "media-spinner__segment",
			opacity: .1,
			style: { "--media-spinner-delay": "0.875s" }
		})
	]
});
const ForwardRef = forwardRef(SpinnerIcon);
//#endregion
export { ForwardRef as default };

//# sourceMappingURL=spinner.js.map